import { Navigate, Outlet } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useAppSelector } from '../../store/hooks';
import { isAdmin } from '../../utils/auth';

// Guards /menu: admins always pass; non-admins need ui_view_menu. Unlike the
// other nav-visibility flags, /menu access is enforced (not just hidden), so a
// non-admin without the flag who navigates here directly is bounced home.
// Waits for the user's UI settings to load before deciding, so an allowed user
// isn't briefly redirected on a hard refresh.
export default function MenuRoute() {
  const loaded = useAppSelector((s) => s.ui.uiSettingsLoaded);
  const canView = useAppSelector((s) => s.ui.uiVisibleComponents.ui_view_menu);

  if (isAdmin()) return <Outlet />;
  if (!loaded) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 'calc(100vh - 120px)' }}>
        <Spinner animation="border" variant="secondary" />
      </div>
    );
  }
  return canView ? <Outlet /> : <Navigate to="/" replace />;
}
